export enum LocationAnalyticsEnum {
  VIEW_LOCATION_MODAL = '[PAC WEB] Localização - Modal de localização visualizada',

  USE_MY_LOCATION = '[PAC WEB] Localização - Clicou em "Usar a minha localização"',
  SEARCH_FOR_LOCATION = '[PAC WEB] Localização - Buscou por um local',

  CLICK_MOST_SEARCHED_CITY = '[PAC WEB] Localização - Clicou em uma "Cidades mais pesquisadas"',
  CLICK_SEARCH_RESULT_CITY = '[PAC WEB] Localização - Clicou no resultado de busca na modal de localização',
}
